<template>
  <div class="subscribe-container">
    <button class="subscribe-button" @click="showSubscriptionModal">
      <span class="subscribe-icon">⭐</span>
      <span class="subscribe-text">{{ buttonText || 'Subscribe' }}</span>
    </button>
    
    <SubscriptionModal 
      :show="isModalVisible" 
      @close="closeModal"
      @select="handleSubscriptionSelect"
    />
  </div>
</template>

<script>
import SubscriptionModal from './SubscriptionModal.vue'

export default {
  name: 'SubscribeButton',
  components: {
    SubscriptionModal
  },
  props: {
    buttonText: {
      type: String,
      default: 'Subscribe'
    }
  },
  data() {
    return {
      isModalVisible: false
    }
  },
  methods: {
    showSubscriptionModal() {
      this.isModalVisible = true
    },
    closeModal() {
      this.isModalVisible = false
    },
    handleSubscriptionSelect(subscriptionType) {
      console.log('Selected subscription:', subscriptionType)
      this.$emit('subscribe', subscriptionType)
      this.closeModal()
    }
  }
}
</script>

<style scoped>
.subscribe-container {
  display: inline-block;
}

.subscribe-button {
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #6C5CE7;
  color: white;
  border: none;
  border-radius: 12px;
  padding: 12px 24px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.2s, transform 0.2s;
}

.subscribe-button:hover {
  background-color: #5A4BD1;
  transform: translateY(-2px);
}

.subscribe-button:active {
  transform: translateY(0);
}

.subscribe-icon {
  margin-right: 8px;
  font-size: 18px;
}
</style> 